import type { Maker } from '../model'
import type { TransKey } from '@root/shared/localization'

export const MAKER_SIZE_LABEL: Record<Maker.MakerSize, TransKey> = {
  whale: 'maker.size.whale',
  dolphin: 'maker.size.dolphin',
  shrimp: 'maker.size.shrimp',
  fish: 'maker.size.fish',
}

export const MAKER_SIZE_DESCRIPTION: Record<Maker.MakerSize, TransKey> = {
  whale: 'maker.size.description.whale',
  dolphin: 'maker.size.description.dolphin',
  shrimp: 'maker.size.description.shrimp',
  fish: 'maker.size.description.fish',
}
